
import { mapGetters } from "vuex";

export default {
  name: "FooterComponent",
  computed: {
    ...mapGetters("business", ["getAddress", "getBusinessRegistrationNumber"]),
  }
};
